import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { addError } from "actions";
import { getRootUrl } from 'helpers/url';
import CourseForm from 'containers/Forms/CourseForm';
import AssignmentForm from 'containers/Forms/AssignmentForm/AssignmentForm';
import MultipleAssignmentForm from 'containers/Forms/AssignmentForm/MultipleAssignmentForm';
import SinglePlanForm from 'containers/Forms/PlanningForm/SinglePlanForm';
import PreschoolPlanningForm from 'containers/Forms/PlanningForm/PreschoolPlanningForm';
import Modal from 'containers/Modals/Modal';
import { Button, TooltipMenu } from '@haldor/ui';

var CloneButton = /*#__PURE__*/function (_Component) {
  _inherits(CloneButton, _Component);

  var _super = _createSuper(CloneButton);

  function CloneButton(props) {
    var _this;

    _classCallCheck(this, CloneButton);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openMultipleAssignmentModal", function () {
      _this.setState({
        multipleAssignment: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        prompt: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      if (_this.state.enableOverlayWarning) {
        _this.setState({
          overlayWarningPrompt: true
        });
      } else {
        _this.setState({
          prompt: false
        });
      }

      if (_this.props.onClose != null && typeof _this.props.onClose === 'function') {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _this.openModal();
    });

    _defineProperty(_assertThisInitialized(_this), "enableOverlayWarningClose", function (enable) {
      _this.setState({
        enableOverlayWarning: enable
      });
    });

    _defineProperty(_assertThisInitialized(_this), "overlayWarningPromptAgree", function () {
      _this.setState({
        prompt: false,
        overlayWarningPrompt: false,
        enableOverlayWarning: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "overlayWarningPromptClose", function () {
      _this.setState({
        overlayWarningPrompt: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeBulkAssignments", function (reload) {
      if (!reload) {
        _this.setState({
          multipleAssignment: false
        });

        if (_this.props.onClose != null && typeof _this.props.onClose === 'function') {
          _this.props.onClose();
        }

        return true;
      }

      if (_this.props.bulkAssignments != null) {
        if (_this.props.bulkAssignments.length > 1) {
          _this.props.addError('Kopior sparade', 'info');
        } else {
          var assignment = _this.props.bulkAssignments[0];

          if (assignment != null && assignment.id != null) {
            window.location = "".concat(getRootUrl(), "assignment/").concat(assignment.id);
          } else {
            _this.setState({
              multipleAssignment: false
            });

            if (_this.props.onClose != null && typeof _this.props.onClose === 'function') {
              _this.props.onClose();
            }
          }

          return true;
        }
      }

      _this.setState({
        multipleAssignment: false
      });

      if (_this.props.onClose != null && typeof _this.props.onClose === 'function') {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement("div", null, _this.props.type == 'assignment' ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.prompt,
        onClose: _this.closeModal,
        title: translate('copy-assignment')
      }, /*#__PURE__*/React.createElement(AssignmentForm, {
        onAbort: _this.closeModal,
        enableOverlayWarningClose: _this.enableOverlayWarningClose,
        overlayWarningPromptAgree: _this.overlayWarningPromptAgree,
        overlayWarningPromptClose: _this.overlayWarningPromptClose,
        overlayWarningPrompt: _this.state.overlayWarningPrompt,
        enableOverlayWarning: _this.state.enableOverlayWarning,
        task: _this.props.object,
        editView: false,
        cloneView: true,
        groupid: _this.props.object.sectionId,
        clearOnUnmount: _this.props.clearOnUnmount
      })) : null, _this.props.type == 'assignment' ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.multipleAssignment,
        onClose: _this.closeBulkAssignments,
        title: translate('copy-assignment')
      }, /*#__PURE__*/React.createElement(MultipleAssignmentForm, {
        onAbort: _this.closeBulkAssignments,
        enableOverlayWarningClose: _this.enableOverlayWarningClose,
        overlayWarningPromptAgree: _this.overlayWarningPromptAgree,
        overlayWarningPromptClose: _this.overlayWarningPromptClose,
        overlayWarningPrompt: _this.state.overlayWarningPrompt,
        enableOverlayWarning: _this.state.enableOverlayWarning,
        initialValues: _this.props.object,
        editView: false,
        cloneView: true,
        groupid: _this.props.object.sectionId,
        clearOnUnmount: _this.props.clearOnUnmount
      })) : null, _this.props.type == 'planning' ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.prompt,
        onClose: _this.closeModal,
        title: _this.props.translate('plan-create-button')
      }, /*#__PURE__*/React.createElement(SinglePlanForm, {
        onAbort: _this.closeModal,
        plan: _this.props.object,
        enableOverlayWarningClose: _this.enableOverlayWarningClose,
        overlayWarningPromptAgree: _this.overlayWarningPromptAgree,
        overlayWarningPromptClose: _this.overlayWarningPromptClose,
        overlayWarningPrompt: _this.state.overlayWarningPrompt,
        enableOverlayWarning: _this.state.enableOverlayWarning,
        editView: false,
        cloneView: true,
        sectionId: _this.props.object.sectionId
      })) : null, _this.props.type == 'preschoolplanning' ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.prompt,
        onClose: _this.closeModal,
        title: _this.props.translate('plan-create-button')
      }, /*#__PURE__*/React.createElement(PreschoolPlanningForm, {
        onAbort: _this.closeModal,
        plan: _this.props.object,
        enableOverlayWarningClose: _this.enableOverlayWarningClose,
        overlayWarningPromptAgree: _this.overlayWarningPromptAgree,
        overlayWarningPromptClose: _this.overlayWarningPromptClose,
        overlayWarningPrompt: _this.state.overlayWarningPrompt,
        enableOverlayWarning: _this.state.enableOverlayWarning,
        editView: false,
        cloneView: true,
        sectionId: _this.props.object.sectionId
      })) : null, _this.props.type == 'course' ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.prompt,
        onClose: _this.closeModal,
        title: _this.props.translate('edit-course')
      }, /*#__PURE__*/React.createElement(CourseForm, {
        onClose: _this.closeModal,
        editView: true,
        course: _this.props.object
      })) : null, _this.props.type == 'assignment' ? /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: /*#__PURE__*/React.createElement(Button, {
          type: "secondary"
        }, _this.props.translate('column-copy'))
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: _this.openMultipleAssignmentModal
      }, _this.props.translate('copy-assignment')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: _this.onClick
      }, _this.props.translate('copy-group-assignment'))) : /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: _this.onClick,
        disabled: false
      }, _this.props.children));
    });

    _this.state = {
      prompt: false,
      multipleAssignment: false,
      enableOverlayWarning: false,
      overlayWarningPrompt: false
    };
    return _this;
  }

  return _createClass(CloneButton);
}(Component);

function mapStateToProps(state) {
  return {
    bulkAssignments: state.assignments.newAssignments,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  addError: addError
})(CloneButton);